import { useForm } from "react-hook-form";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useMemo } from "react";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { ObraAreaChecklist } from "../../../../domain/models/obra_area_checklist";
import { ObraAreaChecklistForm, initialObraAreaChecklist, ObraAreaChecklistSchema } from "../../../schemas/Obras_cadastroarea";
import { ChecklistServicoDropDown } from "../../../../domain/models/checklist_servico_dropdown";

import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";

/**
 * ObraAreaChecklistModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedObraAreaChecklist: ObraAreaChecklist | null,
  checklistServicos: ChecklistServicoDropDown[];
  onClose: () => void;
  onSubmit: (form: ObraAreaChecklistForm) => void;
};

export const ObraAreaChecklistModal = ({
  open,
  saving,
  loading,
  checklistServicos,
  selectedObraAreaChecklist,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ObraAreaChecklistForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: initialObraAreaChecklist,
    resolver: zodResolver(ObraAreaChecklistSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedObraAreaChecklist) {
        hookForm.setValue('area', selectedObraAreaChecklist.descricao ?? '');
        hookForm.setValue('status', selectedObraAreaChecklist.status ?? 0);
        hookForm.setValue('checklists', null);
      } else {
        hookForm.reset(initialObraAreaChecklist);
      }
    }
  }, [
    open,
    hookForm,
    selectedObraAreaChecklist,
  ]);

  const statusOptions = useMemo(() => {
    return [
      {
        id: 0,
        label: 'Em aberto',
        style: {
          backgroundColor: '#f8cb00',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 1,
        label: 'Finalizada',
        style: {
          backgroundColor: '#f3565d',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
    ];
  }, [
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Checklist de área'
      width="50rem"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <FormRadioGroupInput
            name='status'
            label='Status'
            options={statusOptions}
            reactHookForm={hookForm}
          />

          <DefaultFormInput
            name='area'
            label='Área'
            reactHookForm={hookForm}
          />

          <DefaultFormMultiAutocomplete
            name='checklists'
            label='Checklists'
            getOptionKey={x => x.idChecklistServico}
            getOptionLabel={x => x.descricao ?? ''}
            options={checklistServicos}
            chipMaxLength={75}
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal >
  );
}